import Tab from '@/components/korUploadFile/Tab';
import GovGuide from '@/components/MedicalKorUpload/GovGuide';
import Header from '@/components/MedicalKorUpload/Header';
import KakaoGuide from '@/components/MedicalKorUpload/KakaoGuide';
import SubstituteGuideModal from '@/components/MedicalKorUpload/SubstituteGuide.modal';
import { routes } from '@/constant/routes.const';
import { Button } from '@successmode-ktp/kui';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

const Index = () => {
  const [target, setTarget] = useState<'KAKAO' | 'GOV'>('KAKAO');
  const [isOpen, setIsOpen] = useState(false);
  const history = useHistory();

  return (
    <Wrapper>
      <Header title='출입국사실증명서 다운로드 방법' />
      <Container>
        <Tab onChange={(v) => setTarget(v)} />
        {target === 'KAKAO' && <KakaoGuide onClick={() => setIsOpen(true)} />}
        {target === 'GOV' && <GovGuide onClick={() => setIsOpen(true)} />}
        <Button
          type='button'
          size='lg'
          onClick={() => history.push(routes.uploadKorFile)}
        >
          업로드 하러가기
        </Button>
        {isOpen && <SubstituteGuideModal onClick={() => setIsOpen(false)} />}
      </Container>
    </Wrapper>
  );
};
export default Index;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const Container = styled.div`
  position: relative;
  width: 375px;
  padding: 130px 20px 40px;
  @media ${(props) => props.theme.mobile} {
    width: 100%;
  }
`;
